export enum SelectionType {
    ENTITY = 'entity',
    RADIO = 'radio',
    IP_DEVICE = 'ip_device',
    ASSET = 'asset',
    ZONE = 'zone',
    KML_FEATURE_LAYER = 'kmlFeatureLayer',
    CONNECTION = 'connection',
    RF_TRANSMITTER = 'rf_transmitter',
    HEAT_MAP = 'heatMap',
    SITE = 'site',
}

export enum SelectionSubType {
    DEVICE = 'device',
    HERD = 'herd',
    NOTE = 'note',
    TASK = 'task',
    PROTAG_ANIMAL = 'protag_animal',
}
